<ng-container *ngIf="featuredPartners$ | async as featuredPartners">
  <div class="card-link-featured-brands">
    <div class="card-link-featured-brand-box" *ngIf="!!featuredPartners.length">
      <div class="container py-1">
        <h2 class="feature-brand-title font-size-20 fw-bold">{{ Title | translate }}</h2>
        <div class="row">
          <div class="col-4" *ngFor="let partner of featuredPartners | slice: 0:3">
            <div class="d-flex cursor-pointer card-link-featured-brand-item" (click)="navigateToFirstOfferFromAffiliate(partner)">
              <div class="card-link-feature-brand-image">
                <img class="featured_image" src="{{ partner.ImageUrl | contentImage: '7' }}" alt="{{ partner.ImageUrl }}" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-container>
